import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { v4 } from 'uuid';

import { ResetCartError } from '@shared/shopcart/store/shopcart.actions';

export interface QuantitySizeOptions {
    key: number | string;
    value: number | string;
    disable?: boolean;
}

@Component({
    selector: 'quantity-size-selector',
    templateUrl: './quantity-size-selector.component.html',
})

/**
 * Componente para mostrar el selector de tallas y cantidad en los productos de la cesta
 */
export class ShopcartQuantitySizeSelectorComponent implements OnChanges {
    @Input() public readonly name: string;

    @Input() public readonly keySelected;

    @Input() public options: QuantitySizeOptions[];

    @Output() public readonly selectOption = new EventEmitter<QuantitySizeOptions>();

    public optionSelect = null;

    public loaded = true;

    public uidSelectUi = v4();

    constructor(
        private readonly store: Store,
    ) {
    }

    public changeOption(event) {
        this.optionSelect = event.target.value;
        this.selectOption.emit(event.target.value);
        this.store.dispatch(ResetCartError());
    }

    public ngOnChanges(c): void {
        if (this.optionSelect && c?.keySelected?.currentValue?.value.toString() !== this.optionSelect) {
            this.loaded = false;
            // cuando el usuario selecciona una cantidad y en API tenemos otra por errores de cesta por ej
            // el selector ui no se actualiza correctamente
            setTimeout(() => {
                this.loaded = true;
            });
        }
    }
}
